import React, { useEffect, useState } from "react";
import { X, GripVertical, Calendar, Type, Hash } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import MultiselectComponent from "../components/MultiselectComponent";
import DropDownMenu from "../components/DropDownMenu";
import { rulesProperties, allowedRules, showAddedRulesToast } from "../helpers";
import CheckBox from "../components/CheckBox";
import {
  getOutputColumnsData,
  getMappings,
  saveAsMappings,
  getInputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
const initialObjectProperties = {
  appliedRule: 14,
  useOutputOf: null,
  selectOptionFromInput: null,
  output: null,
  customColumnMappings: {},
  inputColumns: [],
  outputColumns: [],
  skipEmptyCells: false,
  skipZeroValues: false,
};
const InvoiceNumberConfig = () => {
  const dispatch = useDispatch();

  const [invoiceObj, setinvoiceObj] = useState(initialObjectProperties);
  const outputColsData = useSelector(getOutputColumnsData);
  const inputColsData = useSelector(getInputColumnsData);
  const currentMaps = useSelector(getMappings);
  const [selectInputCols, setselectInputcols] = useState([]);
  const [selectOutputCols, setselectOutputCols] = useState([]);
  const [components, setComponents] = useState([]);
  const state = useSelector(getEditStateData);
  const [draggedItem, setDraggedItem] = useState(null);
  const [previewDate] = useState(new Date());
  const unSavedChnagesFlag = useSelector(getChangesFlag);

  useEffect(() => {
    if (state?.type === "InvoiceGenerator") {
      setinvoiceObj(state.data);
      console.log(state.data);
      setselectInputcols(
        state.data.inputColumns.map((col) => ({
          label: col,
          value: col,
        })),
      );
      setselectOutputCols(
        state.data.outputColumns.map((col) => ({
          label: col,
          value: col,
        })),
      );
      setComponents(state.data.components || []);
    }
  }, [state?.data, state?.type, state?.data?._id]);

  const dateFormats = [
    { value: "yyyyMMdd", label: "YYYYMMDD" },
    { value: "ddMMyyyy", label: "DDMMYYYY" },
    { value: "MMddyyyy", label: "MMDDYYYY" },
    { value: "yyMMdd", label: "YYMMDD" },
    { value: "ddMMyy", label: "DDMMYY" },
    { value: "MMddyy", label: "MMDDYY" },
    { value: "yyyyMM", label: "YYYYMM" },
    { value: "MMyyyy", label: "MMYYYY" },
  ];

  const dateSeparators = [
    { value: "none", label: "None (20241020)" },
    { value: "-", label: "Dash (2024-10-20)" },
    { value: "/", label: "Slash (2024/10/20)" },
    { value: ".", label: "Dot (2024.10.20)" },
  ];

  const componentTypes = [
    { type: "date", label: "Date", icon: Calendar },
    { type: "text", label: "Static Text", icon: Type },
    { type: "charCode", label: "Character Code", icon: Hash },
    { type: "separator", label: "Separator", icon: Type },
  ];

  const addComponent = (type) => {
    const newComponent = {
      id: Date.now(),
      type,
      label:
        type === "date"
          ? "Date"
          : type === "charCode"
            ? "Char Code"
            : type === "separator"
              ? "Separator"
              : "Text",
    };

    if (type === "date") {
      newComponent.format = "MMddyyyy";
      newComponent.separator = "none";
    }
    if (type === "text") newComponent.value = "";
    if (type === "separator") newComponent.value = "-";

    setComponents([...components, newComponent]);
  };

  const removeComponent = (id) => {
    setComponents(components.filter((c) => c.id !== id));
  };

  const updateComponent = (id, field, value) => {
    setComponents(
      components.map((c) => (c.id === id ? { ...c, [field]: value } : c)),
    );
  };

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;

    const newComponents = [...components];
    const draggedComponent = newComponents[draggedItem];
    newComponents.splice(draggedItem, 1);
    newComponents.splice(index, 0, draggedComponent);

    setComponents(newComponents);
    setDraggedItem(index);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  const formatDateForPreview = (format, separator) => {
    const year = previewDate.getFullYear();
    const month = String(previewDate.getMonth() + 1).padStart(2, "0");
    const day = String(previewDate.getDate()).padStart(2, "0");

    const replacements = {
      yyyy: year,
      yy: String(year).slice(-2),
      MM: month,
      dd: day,
    };

    let result = format;
    Object.keys(replacements).forEach((key) => {
      result = result.replace(new RegExp(key, "g"), replacements[key]);
    });

    // Apply separator if not 'none'
    if (separator && separator !== "none") {
      // Insert separator between date parts
      // Detect the format pattern and insert separators accordingly
      if (format.includes("yyyy")) {
        // For formats like yyyyMMdd, ddMMyyyy, MMddyyyy
        if (format === "yyyyMMdd") {
          result =
            result.slice(0, 4) +
            separator +
            result.slice(4, 6) +
            separator +
            result.slice(6);
        } else if (format === "ddMMyyyy") {
          result =
            result.slice(0, 2) +
            separator +
            result.slice(2, 4) +
            separator +
            result.slice(4);
        } else if (format === "MMddyyyy") {
          result =
            result.slice(0, 2) +
            separator +
            result.slice(2, 4) +
            separator +
            result.slice(4);
        } else if (format === "yyyyMM") {
          result = result.slice(0, 4) + separator + result.slice(4);
        } else if (format === "MMyyyy") {
          result = result.slice(0, 2) + separator + result.slice(2);
        }
      } else if (format.includes("yy")) {
        // For formats like yyMMdd, ddMMyy, MMddyy
        if (format === "yyMMdd") {
          result =
            result.slice(0, 2) +
            separator +
            result.slice(2, 4) +
            separator +
            result.slice(4);
        } else if (format === "ddMMyy") {
          result =
            result.slice(0, 2) +
            separator +
            result.slice(2, 4) +
            separator +
            result.slice(4);
        } else if (format === "MMddyy") {
          result =
            result.slice(0, 2) +
            separator +
            result.slice(2, 4) +
            separator +
            result.slice(4);
        }
      }
    }

    return result;
  };

  const generatePreview = () => {
    return components
      .map((c) => {
        if (c.type === "date")
          return formatDateForPreview(c.format, c.separator);
        if (c.type === "text" || c.type === "separator") return c.value || "";
        if (c.type === "charCode") return "XX";
        return "";
      })
      .join("");
  };

  const handleOnChange = (e) => {
    setinvoiceObj((prev) => {
      return {
        ...prev,
        [e.target.name]:
          e.target.type === "checkbox" ? e.target.checked : e.target.value,
      };
    });

    if (!unSavedChnagesFlag) {
      dispatch(setunSavedRulesChanges(true));
    }
  };
  // write a function for Save Configuration button that will save the data to redux store

  const handleSubmit = () => {
    const isValid = validateCharCodeColumns();
    if (!isValid) return;

    dispatch(
      saveAsMappings({
        ...invoiceObj,
        components: components,
      }),
    );
    showAddedRulesToast(invoiceObj.appliedRule, "added");

    resetConfiguration();
  };
  const validateCharCodeColumns = () => {
    const charCodeColumns = components
      .filter((c) => c.type === "charCode")
      .map((c) => c.id);

    if (charCodeColumns.length === 0) return true; // no charCode components → valid

    const inputColsWithCharCodes = inputColsData.filter(
      (col) =>
        col.inColCharCode && invoiceObj.inputColumns.includes(col.inColChr),
    );

    // If not all input columns have charCodes
    if (inputColsWithCharCodes.length !== invoiceObj.inputColumns.length) {
      const missingCols = invoiceObj.inputColumns.filter((colKey) => {
        const colData = inputColsData.find((ic) => ic.inColChr === colKey);
        return !colData || !colData.inColCharCode;
      });

      if (missingCols.length > 0) {
        alert(
          `The following input columns are missing character codes: ${missingCols.join(
            ", ",
          )}`,
        );
        return false;
      }
    }

    return true; // validation passed
  };

  const resetConfiguration = () => {
    setinvoiceObj(initialObjectProperties);
    setComponents([]);
    setselectInputcols([]);
    setselectOutputCols([]);
  };

  return (
    <div className="w-full py-6">
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 bg-gray-50 p-6 rounded-lg border border-gray-200">
        <MultiselectComponent
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          selectedOptions={selectInputCols}
          handleSetSelect={(selectedOptions) => {
            setselectInputcols(selectedOptions);
            setinvoiceObj((prev) => ({
              ...prev,
              inputColumns: selectedOptions.map((sel) => sel.value),
            }));
          }}
          label={"Select Input Columns"}
          required={true}
        />
        <MultiselectComponent
          options={outputColsData.map((item) => ({
            label: item.outColChr,
            value: item.outColChr,
          }))}
          selectedOptions={selectOutputCols}
          handleSetSelect={(selectedOptions) => {
            setselectOutputCols(selectedOptions);
            setinvoiceObj((prev) => ({
              ...prev,
              outputColumns: selectedOptions.map((sel) => sel.value),
            }));
          }}
          label={"Select Output Columns"}
          required={true}
        />{" "}
        <DropDownMenu
          label={"Use Output of previous Rule"}
          name="useOutputOf"
          value={invoiceObj.useOutputOf || ""}
          required={true}
          options={currentMaps
            .filter((item) => allowedRules.includes(item.appliedRule))
            .map((item) => ({
              label: `${item._id} :  ${
                item.appliedRule
                  ? rulesProperties[item?.appliedRule].ruleName
                  : item.ruleName
              }`,
              value: parseInt(item._id),
            }))}
          onChange={handleOnChange}
        />
      </div>
      {invoiceObj.outputColumns.length === 1 &&
        invoiceObj.inputColumns.length >= 1 && (
          <div className="col-span-2 flex justify-start items-end gap-x-8 my-4">
            <div className="min-h-10 flex">
              <CheckBox
                name={"sameAsOutput"}
                chkBoxText={"Same as output column"}
                onChange={(e) => {
                  if (e.target.checked) {
                    setinvoiceObj((prevState) => ({
                      ...prevState,
                      customColumnMappings: Object.fromEntries(
                        Object.values(prevState.inputColumns).map(
                          (key) => [key, invoiceObj.outputColumns[0]], // 0 because will work if only one output column is selected
                        ),
                      ),
                    }));
                  }
                }}
              />
            </div>
          </div>
        )}
      {invoiceObj.outputColumns?.length > 0 &&
        invoiceObj.inputColumns?.length > 0 && (
          <div className="col-span-2 w-full ">
            <label className="font-semibold">
              Map Input Columns to Output Columns
            </label>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2">
              {invoiceObj.inputColumns.map((column) => (
                <DropDownMenu
                  key={column}
                  label={column}
                  name={column}
                  required={true}
                  value={invoiceObj.customColumnMappings[column] || ""}
                  options={[
                    { label: "Select column", value: "", disabled: true },
                    ...invoiceObj.outputColumns.map((col) => ({
                      label: col,
                      value: col,
                    })),
                  ]}
                  onChange={(e) => {
                    setinvoiceObj((prevState) => ({
                      ...prevState,
                      customColumnMappings: {
                        ...prevState.customColumnMappings,
                        [column]: e.target.value || "",
                      },
                    }));
                  }}
                />
              ))}
            </div>
          </div>
        )}

      {/* processing options */}
      <div className="my-10 p-6 bg-gray-50 rounded-lg border border-gray-200 ">
        <h2 className="text-lg font-semibold text-gray-900 mb-6">
          Processing Options
        </h2>
        <div className=" space-x-4 flex">
          <CheckBox
            name={"skipEmptyCells"}
            chkBoxText={"Skip Empty Cells"}
            checked={invoiceObj.skipEmptyCells}
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
          <CheckBox
            name={"skipZeroValues"}
            chkBoxText={"Skip Zero Values"}
            checked={invoiceObj.skipZeroValues}
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
        </div>
      </div>

      {/* Components List */}
      <div className="mb-10 p-6 bg-gray-50 rounded-lg border border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Add Components
        </h2>
        <div className="flex flex-wrap gap-3">
          {componentTypes.map(({ type, label, icon: Icon }) => (
            <button
              key={type}
              onClick={() => addComponent(type)}
              className="flex items-center gap-2 px-5 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 active:scale-95 font-medium transition-all shadow-md hover:shadow-lg"
            >
              <Icon size={18} />
              <span>{label}</span>
            </button>
          ))}
        </div>
        <h2 className="text-lg font-semibold text-gray-900 my-4">
          Invoice Number Structure (Drag to Reorder)
        </h2>
        <div className="space-y-3 bg-white p-4 rounded-lg border border-gray-200 min-h-32">
          {components.length === 0 ? (
            <div className="text-center py-12 text-gray-400">
              <Calendar className="mx-auto mb-3 opacity-50" size={40} />
              <p>
                No components added yet. Add components above to build your
                invoice number.
              </p>
            </div>
          ) : (
            components.map((component, index) => (
              <div
                key={component.id}
                draggable
                onDragStart={(e) => handleDragStart(e, index)}
                onDragOver={(e) => handleDragOver(e, index)}
                onDragEnd={handleDragEnd}
                className={`flex items-center gap-4 bg-white p-5 rounded-lg border-2 transition-all ${
                  draggedItem === index
                    ? "border-blue-500 bg-blue-50 opacity-75"
                    : "border-gray-200 hover:border-blue-300"
                } cursor-move`}
              >
                <GripVertical
                  className="text-gray-400 flex-shrink-0"
                  size={20}
                />

                <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-2">
                      Type
                    </label>
                    <input
                      type="text"
                      value={component.type.toUpperCase()}
                      disabled
                      className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-sm font-medium text-gray-700"
                    />
                  </div>

                  {component.type === "date" && (
                    <>
                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-2">
                          Date Format
                        </label>
                        <select
                          value={component.format}
                          onChange={(e) =>
                            updateComponent(
                              component.id,
                              "format",
                              e.target.value,
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        >
                          {dateFormats.map((fmt) => (
                            <option key={fmt.value} value={fmt.value}>
                              {fmt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-2">
                          Date Separator
                        </label>
                        <select
                          value={component.separator || "none"}
                          onChange={(e) =>
                            updateComponent(
                              component.id,
                              "separator",
                              e.target.value,
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                        >
                          {dateSeparators.map((sep) => (
                            <option key={sep.value} value={sep.value}>
                              {sep.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  )}

                  {(component.type === "text" ||
                    component.type === "separator") && (
                    <div className="md:col-span-2">
                      <label className="block text-xs font-semibold text-gray-600 mb-2">
                        {component.type === "separator"
                          ? "Separator Character"
                          : "Text Value"}
                      </label>
                      <input
                        type="text"
                        value={component.value}
                        onChange={(e) =>
                          updateComponent(component.id, "value", e.target.value)
                        }
                        placeholder={
                          component.type === "separator"
                            ? "e.g., -, /, _"
                            : "Enter text"
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      />
                    </div>
                  )}

                  {component.type === "charCode" && (
                    <div className="md:col-span-2">
                      <label className="block text-xs font-semibold text-gray-600 mb-2">
                        Character Code Source
                      </label>
                      <p className="text-xs text-gray-500 py-2 px-3 bg-gray-50 rounded-lg">
                        Uses character code from input column (e.g., MA, VM)
                      </p>
                    </div>
                  )}
                </div>

                <button
                  onClick={() => removeComponent(component.id)}
                  className="flex-shrink-0 p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Preview */}
      <div className="mb-6 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border-2 border-blue-200">
        <label className="block text-sm font-semibold text-gray-700 mb-3">
          Preview
        </label>
        <div className="text-2xl font-mono font-bold text-blue-900">
          {generatePreview() || "Add components to see preview"}
        </div>
        <p className="text-xs text-gray-600 mt-2">
          Example using date: {previewDate.toLocaleDateString()} and character
          code: XX
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3">
        <button
          className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 font-semibold transition-colors"
          onClick={handleSubmit}
        >
          Save Configuration
        </button>
        <button
          onClick={resetConfiguration}
          className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 font-semibold transition-colors"
        >
          Clear All
        </button>
      </div>
    </div>
  );
};

export default InvoiceNumberConfig;
